"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  statisticalAnalysis: {
    common: {
      stAnalysis: 'Statistical Analysis',
      materialInOutRecord: 'Material In Out Record',
      spareInOutRecord: 'Spare In Out Record',
      pleaseEnter: 'Please enter the',
      pleaseChoose: 'Please select'
    },
    drugList: {
      drugList: 'Drug List',
      vesselName: 'Vessel Name',
      listDescription: 'Drug List Description',
      operationManual: 'Operation Manual',
      listSetting: 'Drug List Setting',
      code: 'Labeling Number',
      treatment: 'Treatment',
      drug: 'Drug',
      specifications: 'Specifications',
      recommendedAmount: 'Recommended Amount',
      currentInventory: 'Current Inventory',
      periodOfValidity: 'Period Of Validity',
      stockRemark: 'Stock Remark',
      outStockRemark: 'Out of Stock Remark',
      remark: 'Remark',
      recommend: 'Recommend',
      companyRequirements: 'Company Requirements',
      classOfControlledDrugs: 'Class of Controlled Drugs',
      extFlag: 'External Application',
      controlFlag: 'Controlled Drugs',
      drugNo: 'Drug no.',
      drugCategory: 'Drug Category',
      drugName: 'Drug Name',
      drugNameEn: 'Drug Name(EN)',
      specifications2: 'Specifications',
      unit: 'Unit',
      medicineOut: 'Drug delivery',
      registerPeriod: 'Registration Validity Period',
      outType: 'Outbound type',
      allOutStock: 'All Out of Stock',
      outQty: 'Number of shipments',
      outSuccess: 'Successfully shipped out',
      plsSelectData: 'Please tick the data that needs to be manipulated',
      searchOnlyBeInvalid: 'Only show pre-expired medicines',
      showVesselCertificate: 'Show Vessel Certificate'
    },
    keyWordFilter: {
      obm: 'Can query material name, material number, material supplier',
      obp: 'You can inquire equipment name, spare part name, spare part number, drawing number, spare part supplier'
    },
    onBoardPartsList: {
      oBPList: 'Spare Part On Board List',
      shipName: 'Vessel',
      department: 'Dept',
      hasHarmfulSt: 'Contains hazardous substances',
      allParts: 'All',
      onParts: 'In the spare parts',
      locationParts: 'The inventory of spare parts',
      deleteParts: 'Ruined the spare parts',
      shipNm: 'Vessel Name',
      putLocation: 'Store location',
      eqpName: 'Device Name',
      partsNum: 'Equipment Model',
      status: 'Using State',
      eqpSerialNum: 'Device serial number',
      partsSupplier: 'Spare parts supplier',
      partsName: 'Spare Name',
      partsNo: 'Spare no.',
      drawingNo: 'Drawing no.',
      inDrawingNo: 'In Drawing no.',
      unit: 'Unit',
      quantity: 'Quantity'
    },
    onBoardMaterialList: {
      mtrList: 'Material On Board List',
      shipName: 'Vessel',
      department: 'Dept',
      hasHarmfulSt: 'Contains hazardous substances',
      allParts: 'All',
      onParts: 'In Use Store',
      locationParts: 'The Inventory of Store',
      deleteParts: 'Ruined the Store',
      shipNm: 'Vessel Name',
      putLocation: 'Store location',
      eqpName: 'Apply Type',
      partsNum: 'Store Category',
      status: 'Using State',
      partsSupplier: 'Store Supplier',
      partsName: 'Store Name',
      partsNo: 'Store Code',
      drawingNo: 'Specification model',
      unit: 'Unit',
      quantity: 'QTTY'
    },
    applyTracking: {
      spsTracking: 'Spare parts application tracking',
      shipName: 'Vessel Name',
      applyNo: 'Apply no.',
      equipmentName: 'Equipment Name',
      currentLinks: 'Current Links',
      supplierCode: 'Supplier Code',
      airPreparationCode: 'Navigational Organizing Code',
      serviceTypes: 'Service Types',
      supplier: 'Supplier',
      poNo: 'Po no.',
      orderAmount: 'Total Order Amount ',
      orderedDate: 'Order Date',
      confirmDate: 'Order confirmation date',
      endDate: 'Ready date',
      logisticsProvider: 'Logistics providers',
      waybillNumber: 'Waybill no.',
      shipSupplyDate: 'For the ship date',
      signForDate: 'Date of receipt',
      mtrTracking: 'Material application tracking',
      dept: 'Dept',
      applyType: 'Apply Category',
      lgReceDate: 'LgRece Date'
    },
    sparePartsStatistical: {
      spsStatistical: 'Spare Parts Statistical',
      locationGroup: 'Grouping by storage location',
      locationMsg: 'Location information',
      searchTime: 'Query by time period',
      startTime: 'Start Time',
      endTime: 'End Time',
      company: 'Company',
      shipName: 'Vessel Name',
      equipmentName: 'Equipment Name',
      equipmentNo: 'Equipment no.',
      spsName: 'Spare Name',
      spsNo: 'Spare no.',
      drawingNo: 'Drawing no.',
      drawingItem: 'In Drawing no.',
      unit: 'Unit',
      locationName: 'Location Name',
      spsType: 'Spare Category',
      lastLocation: 'Before the inventory',
      medInStocky: 'During storage',
      medConsume: 'Consumption during',
      location: 'Inventory',
      minStocky: 'Minimum Inventory',
      remark: 'Remark',
      mtrStatistical: 'Material Parts Statistical',
      dept: 'Dept',
      custodian: 'Depository',
      applyType: 'Apply Category',
      mtrType: 'Material Category',
      mtrName: 'Material Name',
      mtrNo: 'Material no.',
      esc: 'Spec'
    },
    budgetPerformance: {
      bPef: 'Budget Performance',
      company: 'Company',
      shipName: 'Vessel Name',
      costType: 'Cost categories',
      costSub: 'Business subjects',
      year: 'Year',
      shipComp: 'Comparison of ship expenses',
      companyComp: 'Comparison of company expenses',
      costComp: 'Comparison of subjects and expenses',
      budget: 'Budget',
      actualUse: 'Actual use',
      fleet: 'Fleet',
      secondSub: 'Secondary subject',
      thirdSub: 'Level 3 subjects'
    }
  }
};